sharpen-page-navigation {
  font-family: var(--font-family-serif);
  display: flex;
  margin-bottom: var(--spacing-md);

  sharpen-nav-link {
    display: flex;
    flex: 1;

    a {
      display: flex;
      flex: 1;
      align-items: center;

      text-decoration: none;
      color: var(--color-evergreen);
      padding: var(--spacing-xs) var(--spacing-sm);
      
    }

    &[selected="true"] a {
      border-radius: var(--border-radius-sm);
      background-color: var(--color-evergreen);
      color: white;
      text-decoration: none;
    }

    .sharpen-icon { margin-right: var(--spacing-xs); }
  }
}

@include media-breakpoint-up(md) {
  sharpen-page-navigation {
    flex-direction: column;

    sharpen-nav-link a {
      padding: var(--spacing-sm) var(--spacing-md);
    }
  }
}